"use client";

import { useEffect } from "react";

const GA_ID = process.env.NEXT_PUBLIC_GA_ID;

export default function Analytics() {
  useEffect(() => {
    if (!window.gtag) {
      // Load GA script dynamically if not already present
      const script = document.createElement("script");
      script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
      script.async = true;
      document.head.appendChild(script);

      // Init gtag
      script.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag(...args: any[]) {
          window.dataLayer.push(args);
        }
        window.gtag = gtag;

        gtag("js", new Date());
        gtag("config", GA_ID, {
          page_path: window.location.pathname,
        });
      };
    }

    // OSM5 Analytics
    const osmScript = document.createElement("script");
    osmScript.src = "https://sdks.osm5.com/js/osm5.min.js";
    osmScript.async = true;
    document.head.appendChild(osmScript);

    osmScript.onload = () => {
      (window as any).OSM5Analytics?.init({
        endpoint: "https://a.osm5.com",
        siteId: "1ja3glqgm-7hay6qIXLa",
        autoCollect: true,
        autoTrackInteractionsMode: "detailed",
        autoCollectAPIStats: true,
        mode: "detailed",
      });
    };
  }, []);

  return null;
}
export const sendClickEvent = ({
  category,
  action,
  label,
  value,
  extraParams = {},
}: {
  category: string;
  action: string;
  label?: string;
  value?: number;
  extraParams?: Record<string, any>; // for custom dimensions/parameters
}) => {
  if (typeof window !== "undefined" && window.gtag) {
    window.gtag("event", action, {
      event_category: category,
      event_label: label,
      value,
      ...extraParams,
    });
  }
};
